import ApiService from '@shared/services/api.service';

const DataService = {
  getTimezones() {
    return ApiService.get('/available_timezones');
  },
  getEnums() {
    return ApiService.get('/enums');
  },
  getUserAgents() {
    return ApiService.get('/available_user_agents').then(response => {
      return response.reverse(); // List is reverse order so that the latest user agent is at the top
    });
  },
  getUsers() {
    return ApiService.get('/impersonated_user');
  },
  fetchStatusJob(jobId) {
    return ApiService.get(`/frontend_job/${jobId}`);
  }
};

export default DataService;
